import React, {Component, PropTypes} from 'react';
import ConfirmationModal from '../../../../../shared/components/confirmation-modal/index';

function handleClose() {

    this.setState({isModalOpen: false});

}

function handleOpen() {

    this.setState({isModalOpen: true});

}

function handleConfirm() {

    this.setState({isModalOpen: false});
    this.props.onDelete(this.props.file);

}

class ConfirmDeleteButton extends Component {

    state = {
        isModalOpen: false
    };

    render() {

        return (
            <section className='confirm-delete'>
                <button
                    className='button-text button-delete-icon'
                    onClick={this::handleOpen}
                >
                    <span className='icon-trash-can'/>
                </button>
                <ConfirmationModal
                    confirmMessage='CONFIRM_DELETE_ATTACHMENT'
                    isOpen={this.state.isModalOpen}
                    onClose={this::handleClose}
                    onConfirm={this::handleConfirm}
                    title='DELETE_ATTACHMENT'
                />
            </section>
        );

    }
}

ConfirmDeleteButton.displayName = 'ConfirmDeleteButton';

ConfirmDeleteButton.propTypes = {
    file: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default ConfirmDeleteButton;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/duplicate-pin-plate-form/file-attachment-panel-cloud/confirm-delete-button-cloud.js